import { useEffect, useState } from 'react';
import { getCookie } from '@/utils/tool';
import Consts from '@/constants/const';
import { getSimpleAccountInfo } from '@/api/customer';
import useTranslation from 'next-translate/useTranslation';
import usePageMountEffect from './usePageMountEffect';

export type UserInfoType = {
  userId?: number | string; // 用户ID
  userName?: string; // 昵称
  userEmail?: string; // email
  isVip?: boolean; // vip
  vipExpireTime?: number; // vip过期时间戳
  phone?: string; // 电话
  userImageUrl?: string; // 头像
  lang?: string;
  zipcode?: string;
  productPrivilege?: boolean; // 产品编辑权限
  levelIcon?: string; // rewards 等级icon
  loyaltyLevel?: number; // user loyalty tier
  userType?: string;
};

export default function useUserInfo() {
  const [userInfo, setUserInfo] = useState<UserInfoType>();
  const { lang } = useTranslation('common');

  const getUserInfo = async () => {
    const res = await getSimpleAccountInfo();
    const info = res?.object || {};
    return setUserInfo({
      userName: info?.alias || '',
      userImageUrl: info?.head_img_url || '',
      userId: info?.user_id || getCookie(Consts.USER_ID) || null,
      isVip: info?.member || false,
      vipExpireTime: info?.member_expire_timestamp || null,
      phone: info?.phone_number || '',
      lang: lang || 'en',
      zipcode: info?.filter?.zipcode || getCookie(Consts.ZIP_CODE) || '',
      productPrivilege: info?.product_privilege,
      levelIcon: info?.loyalty_vip?.level_icon,
      loyaltyLevel: info?.loyalty_vip?.level,
      userType: info?.user_type
    });
  };

  usePageMountEffect(() => {
    getUserInfo();
  }, []);

  return {
    ...userInfo
  };
}
